import { createSlice } from '@reduxjs/toolkit';

const intelligentSlice = createSlice({
  name: 'intelligent',
  initialState: {},
  reducers: {},
});

export default intelligentSlice.reducer;
